
export const datepickerFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMMM YYYY'
  },
};

export const seriesUnitOptions = [
  {
    value: 'year',
    viewValue: 'anms.stats.unit.year'
  },
  {
    value: 'month',
    viewValue: 'anms.stats.unit.month'
  },
  {
    value: 'day',
    viewValue: 'anms.stats.unit.day'
  },
  {
    value: 'hour',
    viewValue: 'anms.stats.unit.hour'
  },
];

